import React, { useState } from 'react';
import { BrandLogo } from './BrandLogo';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { useToast } from './ui/Toast';
import { useAuth, AuthRole } from '../contexts/AuthContext';

const COPY: Record<AuthRole, { title: string; subtitle: string }> = {
  admin: { title: 'Acceso Admin', subtitle: 'Ingresa la clave de administrador' },
  kitchen: { title: 'Acceso Cocina', subtitle: 'Ingresa la clave de cocina' }
};

export const LoginForm = ({ role = 'admin' as AuthRole }: { role?: AuthRole }) => {
  const { login } = useAuth();
  const { showToast } = useToast();
  const [passcode, setPasscode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { title, subtitle } = COPY[role];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      await login(passcode, role);
    } catch (error) {
      showToast('Clave incorrecta', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-background-light dark:bg-background-dark">
      <Card className="w-full max-w-sm p-8">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="flex flex-col items-center gap-3 text-center">
            <BrandLogo className="h-24 w-24" />
            <div>
              <h1 className="text-xl font-black">{title}</h1>
              <p className="text-slate-500 text-sm">{subtitle}</p>
            </div>
          </div>

          <input
            autoFocus
            required
            type="password"
            value={passcode}
            onChange={(e) => setPasscode(e.target.value)}
            className="w-full bg-slate-100 dark:bg-slate-900 border-none rounded-2xl py-3 px-4 text-center tracking-widest focus:ring-2 focus:ring-primary/20"
            placeholder="Clave"
          />

          <Button type="submit" isLoading={isLoading} className="w-full h-12 rounded-2xl font-black">
            Entrar
          </Button>
        </form>
      </Card>
    </div>
  );
};
